export const ASSIGN_TO_ADDON = `
  mutation AssignToAddon($input: AssignToAddonInput!) {
    addon {
      assignToAddon(input: $input) {
        success
        message
      }
    }
  }
`;
